import { abyssColors } from '@/theme/colors';
import { Stack } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const ReviewContainer = muiStyled(Stack)(() => ({
  width: '100%',
  minWidth: '153.6rem',
  padding: '2.4rem',
  background: abyssColors.primary[50],
  borderRadius: '0.4rem',
  flexDirection: 'row',
  gap: '2.4rem',
}));

export const ReviewCard = muiStyled(Stack)(() => ({
  width: '100%',
  padding: '2.5rem',
  gap: '2.4rem',
  background: abyssColors.neutral[50],
  borderRadius: '0.8rem',
  border: `0.1rem solid ${abyssColors.primary[100]}`,
}));

export const CardIcon = muiStyled(Stack)(({ backgroundColor }: { backgroundColor: string }) => ({
  width: '2.4rem',
  height: '2.4rem',
  borderRadius: '0.4rem',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor,
}));
